import { getAltresDades } from 'api/services/wp';
import { useEffect, useState } from 'react';
import './HomeBannersButtons.scss';
import { Fade } from 'react-awesome-reveal';
import { uniqueId } from 'lodash';

function HomeBannersButtons() {
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    getAltresDades().then(({ data }) => {
      const fetchedButtons = data[0]?.acf?.botons_homepage || [];
      setButtons(fetchedButtons);
    });
  }, []);

  if (!buttons.length) {
    return null;
  }

  return (
    <div className="home-banners-buttons d-flex flex-align-items-center flex-justify-center flex-gap-lg flex-wrap">
      <Fade triggerOnce delay={200}>
        {buttons.map((button) => (
          <a
            href={button.enllac}
            key={uniqueId('home-banner-button-')}
            target="_blank"
            rel="noreferrer"
          >
            <img src={button.imatge} alt="Botó de la homepage" />
          </a>
        ))}
      </Fade>
    </div>
  );
}

export default HomeBannersButtons;
